module.exports = __webpack_public_path__ + "assets/bell-icon-black.662d0350.svg";